// import React, { useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import base_url from '../config/Config';
// import Navigation from '../components/Navigation';
// import Sidebar from '../components/Sidebar';
// import Cookies from 'js-cookie';

// const AddEmployee = () => {
//     const [formData, setFormData] = useState({
//         adminId: '',
//         adminPassword: '',
//         employeeName: '',
//         employeeId: '',
//         isActive: true
//     });

//     const token = Cookies.get('authToken');
//     const navigate = useNavigate();

//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setFormData({
//             ...formData,
//             [name]: type === 'checkbox' ? checked : value
//         });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             await axios.post(`${base_url}/api/admin/add`, formData, {
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${token}`
//                 }
//             });
//             alert("Admin Added Successfully");
//             navigate("/employee/AllEmployee");
//         } catch (err) {
//             console.error("Add Error:", err);
//             alert("Failed to Add Admin");
//         }
//     };

//     return (
//         <>
//             <div className='overviewsaa'>
//                 <h4>Add Admin</h4>
//             </div>
//             <div className='navigationss mb-5'>
//                 <Navigation />
//             </div>
//             <div className='container-fluid'>
//                 <div className='row'>
//                     <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//                         <div className='lmssidebar'>
//                             <Sidebar />
//                         </div>
//                     </div>
//                     <div className='col-lg-10 col-md-10'>
//                         <div className='dashboardlms mt-5 text-center'>
//                             <div className='row'>
//                                 <hr />
//                                 <div className='col-md-12 col-lg-12'>
//                                     <div className='dashboardlms mt-3'>
//                                         <form onSubmit={handleSubmit}>
//                                             <div className='row'>
//                                                 <div className='col-md-12'>
//                                                     <div className='row'>

//                                                         <div className='col-md-4 col-lg-4'>
//                                                             <div className='personaldetails text-justify mt-3'>
//                                                                 <label htmlFor="adminId">Employee User ID</label><br />
//                                                                 <input type="text" name="adminId" id="adminId" placeholder='Admin ID' onChange={handleChange} required />
//                                                             </div>
//                                                         </div>

//                                                         <div className='col-md-4 col-lg-4'>
//                                                             <div className='personaldetails text-justify mt-3'>
//                                                                 <label htmlFor="adminPassword">Password</label><br />
//                                                                 <input type="password" name="adminPassword" id="adminPassword" placeholder='Password' onChange={handleChange} required />
//                                                             </div>
//                                                         </div>

//                                                         <div className='col-md-4 col-lg-4'>
//                                                             <div className='personaldetails text-justify mt-3'>
//                                                                 <label htmlFor="employeeName">Employee Name</label><br />
//                                                                 <input type="text" name="employeeName" id="employeeName" placeholder='Employee Name' onChange={handleChange} required />
//                                                             </div>
//                                                         </div>

//                                                         <div className='col-md-4 col-lg-4'>
//                                                             <div className='personaldetails text-justify mt-3'>
//                                                                 <label htmlFor="employeeId">Employee ID</label><br />
//                                                                 <input type="text" name="employeeId" id="employeeId" placeholder='Employee ID' onChange={handleChange} required />
//                                                             </div>
//                                                         </div>
//                                                         <div className='col-md-4 col-lg-4'>
//                                                             <div className='personaldetails text-justify mt-3'>
//                                                                 <label htmlFor="branchName">Branch Name</label><br />
//                                                                 <input type="text" name="branchName" id="branchName" placeholder='branchName' onChange={handleChange} required />
//                                                             </div>
//                                                         </div>
//                                                         <div className='col-md-4 col-lg-4'>
//                                                             <div className='personaldetails text-justify mt-4'>
//                                                                 <label>
//                                                                     <input type="checkbox" name="isActive" checked={formData.isActive} onChange={handleChange} />
//                                                                     {' '}Active
//                                                                 </label>
//                                                             </div>
//                                                         </div>

//                                                         <div className='col-md-12 col-lg-12'>
//                                                             <div className='buttonss mb-5 mt-5 text-center'>
//                                                                 <button type="submit">Save</button>
//                                                             </div>
//                                                         </div>

//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </div>
//                             </div> {/* row */}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default AddEmployee;


import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import base_url from "../config/Config";
import Navigation from "../components/Navigation";
import Sidebar from "../components/Sidebar";
import Cookies from "js-cookie";

const AddEmployee = () => {
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        roles: "",
        employeeName: "",
        employeeId: "",
        branchName: "",
    });

    const token = Cookies.get("authToken");
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.roles) {
            alert("Please select a Role before submitting!");
            return;
        }

        const payload = {
            username: formData.username,
            password: formData.password,
            roles: [formData.roles],
            employeeName: formData.employeeName,
            employeeId: formData.employeeId,
            branchName: formData.branchName,
        };

        try {
            await axios.post(`${base_url}/api/auth/addUser`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            alert("Employee Added Successfully");
            navigate("/employee/AllEmployee");
        } catch (err) {
            console.error("Add Error:", err);
            alert("Failed to Add Employee");
        }
    };

    return (
        <>
            <div className="overviewsaa">
                <h4>Add Employee</h4>
            </div>
            <div className="navigationss mb-5">
                <Navigation />
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-2 col-md-2 sidebarnavigartion">
                        <div className="lmssidebar">
                            <Sidebar />
                        </div>
                    </div>
                    <div className="col-lg-10 col-md-10">
                        <div className="dashboardlms  text-center">
                            <div className="row">
                                <hr />
                                <div className="col-md-12 col-lg-12">
                                    <div className="dashboardlms mt-3">
                                        <form onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-4 col-lg-4">
                                                    <div className="personaldetails text-justify mt-3">
                                                        <label htmlFor="username">Username</label>
                                                        <input
                                                            type="text"
                                                            name="username"
                                                            id="username"
                                                            placeholder="Enter Username"
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-lg-4">
                                                    <div className="personaldetails text-justify mt-3">
                                                        <label htmlFor="password">Password</label>
                                                        <input
                                                            type="password"
                                                            name="password"
                                                            id="password"
                                                            placeholder="Enter Password"
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-lg-4">
                                                    <div className="personaldetails text-justify mt-3">
                                                        <label htmlFor="roles">Select Role</label>
                                                        <select name="roles"
                                                            id="roles"
                                                            value={formData.roles}
                                                            onChange={handleChange}
                                                            required
                                                        >
                                                            <option value="">-- Select Role --</option>
                                                            <option value="ROLE_ADMIN">Admin</option>
                                                            <option value="ROLE_USER">User</option>
                                                            <option value="ROLE_MANAGER">Manager</option>
                                                            <option value="ROLE_VIEWER">Viewer</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-lg-4">
                                                    <div className="personaldetails text-justify mt-3">
                                                        <label htmlFor="employeeName">Employee Name</label>
                                                        <input
                                                            type="text"
                                                            name="employeeName"
                                                            id="employeeName"
                                                            placeholder="Enter Employee Name"
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-lg-4">
                                                    <div className="personaldetails text-justify mt-3">
                                                        <label htmlFor="employeeId">Employee ID</label>
                                                        <input
                                                            type="text"
                                                            name="employeeId"
                                                            id="employeeId"
                                                            placeholder="Enter Employee ID"
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-lg-4">
                                                    <div className="personaldetails text-justify mt-3">
                                                        <label htmlFor="branchName">Branch Name</label>
                                                        <input
                                                            type="text"
                                                            name="branchName"
                                                            id="branchName"
                                                            placeholder="Enter Branch Name"
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-12 col-lg-12">
                                                    <div className="buttonss mb-5 mt-5 text-center">
                                                        <button type="submit">Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddEmployee;
